export const Blogs = [
  {
    id: 20,
    name: "YouTube — 123K subscribers",
    tags: ["YouTube", "System Design", "AI Agents"],
    date: "Tamil technology education",
    imgSrc: "/logo.png",
    link: "/youtube",
    internal: true,
  },
  {
    id: 19,
    name: "Vanakkam DSA — 1000+ students, 7 cohorts",
    tags: ["Tamil", "DSA", "Hayan Tech"],
    date: "Founded by Hareesh Rajendran",
    imgSrc: "/images/vanakkam-dsa-logo.png",
    link: "/vanakkam-dsa",
    internal: true,
  },
  {
    id: 18,
    name: "GitHub — 1.8K followers, 69 repositories",
    tags: ["Open Source", "Pull Shark", "Starstruck"],
    date: "github.com/hareesh-r",
    imgSrc: "/logo.png",
    link: "/open-source",
    internal: true,
  },
  {
    id: 21,
    name: "Instagram — 40K followers",
    tags: ["Instagram", "Hareesh Rajendran"],
    date: "@hareeshrajendran_",
    imgSrc: "/logo.png",
    link: "https://www.instagram.com/hareeshrajendran_/",
  },
  {
    id: 17,
    name: "LeetCode Knight — 2,067 rating, top 1.84%",
    tags: ["leetcode", "dsa", "java"],
    date: "780 LeetCode · 4,000+ across platforms · top 20 in India in one contest",
    imgSrc: "https://leetcard.jacoblin.cool/hareeshprogrammer?ext=contest",
    link: "https://leetcode.com/u/hareeshprogrammer",
  },
  {
    id: 15,
    name: "Mentee - Amazon ML Summer School",
    tags: ["ML", "Machine Learning", "Data Science", "Data Analysis"],
    date: "4 weeks apprenticeship program",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/download.png?alt=media&token=6a694785-b91b-435e-910e-aa73754e625e",
    link: "https://www.amazon.in/Mentee-Amazon-ML-Summer-School/dp/B07JQZQZQZ",
  },
  {
    id: 14,
    name: "Zoho - Summer Intern",
    tags: ["SQL", "JDBC", "JAVA", "KAFKA"],
    date: "Software Development Intern",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/zoho-logo.png?alt=media&token=2d6bf5e7-1d2b-4fad-b3e3-1a8f445190d6",
    link: "https://www.zoho.com/",
  },
  {
    id: 13,
    name: "Bit Brothers - Junior Javascript Developer",
    tags: ["ReactJS", "MaterialUI", "Figma", "Github"],
    date: "Worked on Real world projects and Collaborated using GitHub by using conventional commits",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/bitbros.png?alt=media&token=367f4b3d-5d48-4bb6-bdb2-3aa5509c41bb",
    link: "https://bitbrothers.in/",
  },
  {
    id: 12,
    name: "Mineral Drop - Frontend Development Intern",
    tags: ["Netlify", "GitHub", "Godaddy", "FireBase"],
    date: "6 months long Internship in Mineral Drop , Made me do incredible web designs ",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/mindrop.png?alt=media&token=365a56e9-f204-4955-8316-4dd85b415b8f",
    link: "https://mineraldrop.in",
  },
  {
    id: 11,
    name: "Fashioo.in - Frontend Development Intern",
    tags: ["HTML", "CSS", "BootStrap", "JavaScript"],
    date: "Worked as a Frontend Developer Netlify , GitHub , SEO Multimedia Manipulation",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/fashioo.jfif?alt=media&token=3ef77672-550a-43d3-bc1a-989ed7dd8e32",
    link: "https://fashioo.in",
  },
  {
    id: 10,
    name: "Gmail Login using Python Selenium",
    tags: ["Geeks For Geeks", "Article", "python", "selenium"],
    date: "Jul 14, 2020",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/gfg.png?alt=media&token=b416e9e5-cef2-40ce-be6b-3bbd5f41a5c1",
    link: "https://www.geeksforgeeks.org/gmail-login-using-python-selenium/",
  },
  {
    id: 9,
    name: "I'm a content creator and Admin @technamite",
    tags: ["instagram", "tech", "content", "admin"],
    date: "23 Feb, 2020 - Present",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/technamite%20logo.png?alt=media&token=fb6c6f6f-d3a3-4b03-a8e1-9f0d989db707",
    link: "https://www.instagram.com/technamite/",
  },
  {
    id: 8,
    name: "Google Cloud Community India Learn to Earn Cloud Security Challenge: Level 2",
    tags: ["Google", "Cloud", "Cloud", "Security"],
    date: "6 July, 2021",
    imgSrc:
      "https://cdn.qwiklabs.com/X5Ngy9b5EeSYwJ4BajDQmvS2LB3KmqU07Krx6K2jtrg%3D",
    link: "https://www.cloudskillsboost.google/public_profiles/e7acb751-2ffa-43cf-9436-779913a65daf/badges/1647215?utm_medium=social&utm_source=linkedin&utm_campaign=ql-social-share",
  },
  {
    id: 7,
    name: "Machine Learning",
    tags: ["Applied ML", "Data Science", "Data Analysis"],
    date: "Internshala - Credential ID : 0664361D-388D-E9FE-CDEE-52C350E6A7D9",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/internshala_og_image.jpg?alt=media&token=d6528be6-79ff-445c-acd7-c1bdd3c13b13",
    link: "https://trainings.internshala.com/verify_certificate",
  },
  {
    id: 6,
    name: "Build a Face Recognition Application using Python",
    tags: ["Guiness", "AI-For-India", "Artificial Intelligence"],
    date: "GUVI Geek Networks, IITM Research Park ",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/guvi.png?alt=media&token=b008e54e-8c49-4b68-a96b-168298514e75",
    link: "https://www.guvi.in/verify-certificate?id=4iW3B7712GQ8191O63#",
  },
  {
    id: 5,
    name: "Getting Started with AWS Machine Learning",
    tags: ["coursera", "aws", "machine-learning"],
    date: "Coursera certification - May 29, 2020",
    imgSrc:
      "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~8XDVWW4YGHY5/CERTIFICATE_LANDING_PAGE~8XDVWW4YGHY5.jpeg",
    link: "https://www.coursera.org/account/accomplishments/verify/8XDVWW4YGHY5",
  },
  {
    id: 4,
    name: "Practical Java course : Zero to One",
    tags: ["Java", "Udemy", "OOPS"],
    date: "Udemy Certification",
    imgSrc:
      "https://udemy-certificate.s3.amazonaws.com/image/UC-f6b0a490-1813-4b8c-9e25-cdaa38dbbea9.jpg?v=1589915024000",
    link: "https://www.udemy.com/certificate/UC-f6b0a490-1813-4b8c-9e25-cdaa38dbbea9/",
  },
  {
    id: 3,
    name: "The Python 3 Course - Learn Python Practically",
    tags: ["Python", "OOPS", "Udemy"],
    date: "Udemy Certification",
    imgSrc:
      "https://udemy-certificate.s3.amazonaws.com/image/UC-b1fefa2f-d02f-4325-ae29-19f96dc7c919.jpg?v=1590409067000",
    link: "https://www.udemy.com/certificate/UC-b1fefa2f-d02f-4325-ae29-19f96dc7c919/",
  },
  {
    id: 2,
    name: "Skillrack coding profile",
    tags: ["skillrack", "regional competetive coding", "coding"],
    date: "First year of Coding",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/srack.jpg?alt=media&token=5205cc9a-ef54-4781-9296-9bf3def6e1e0",
    link: "https://www.skillrack.com/faces/resume.xhtml?id=258957&key=be07621cdc077b395521f8fe439050c4d537901e",
  },
  {
    id: 1,
    name: "Cognitive class Python 101 Data science course",
    tags: ["python", "datas cience", "machine learning"],
    date: "June 7, 2020",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/hareesh-e153f.appspot.com/o/Cognitive-Class.jpg?alt=media&token=358a0cdf-e681-4f42-9b36-009213259773",
    link: "https://courses.cognitiveclass.ai/certificates/b01765909a884866b155a54bf0ef109b",
  },
  // ,
  // {
  //   id: 15,
  //   name: "",
  //   tags: ["", ""],
  //   date: "",
  //   imgSrc: "",
  //   link: "",
  // },
];
